import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=1a46c797&"
import script from "./OverviewTab.vue?vue&type=script&lang=js&"
export * from "./OverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports